import md5 from 'blueimp-md5';
const tool = {
    urlSecurityCheck(params?) {
        params = md5(params ? JSON.stringify(params) : '');
        const time = new Date().getTime();
        const key = 'uajskakf893jd';
        const no = md5(
            Math.round(Math.random() * 10000) + Math.random() + time
        );
        const sign = md5(params + time + no + key);
        const returnObj = {
            queryString: `time=${time}&no=${no}&sign=${sign}`,
            queryObj: {
                time,
                no,
                sign,
            },
        };
        return returnObj;
    },
    readablizeBytes(bytes) {
        // 字节转换
        const s = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
        const e = Math.floor(Math.log(bytes) / Math.log(1024));
        console.log(bytes);
        return (bytes / Math.pow(1024, Math.floor(e))).toFixed(2) + ' ' + s[e];
    },
    isObject(o) {
        // 判断是否为对象
        return (typeof o === 'object' || typeof o === 'function') && o !== null;
    },
    getScrollTop() {
        // 滚动条在Y轴上的滚动距离
        let scrollTop = 0;
        let bodyScrollTop = 0;
        let documentScrollTop = 0;
        if (document.body) {
            bodyScrollTop = document.body.scrollTop;
        }
        if (document.documentElement) {
            documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop =
            bodyScrollTop - documentScrollTop > 0
                ? bodyScrollTop
                : documentScrollTop;
        return scrollTop;
    },
    getScrollHeight() {
        // 文档的总高度
        let scrollHeight = 0;
        let bodyScrollHeight = 0;
        let documentScrollHeight = 0;
        if (document.body) {
            bodyScrollHeight = document.body.scrollHeight;
        }
        if (document.documentElement) {
            documentScrollHeight = document.documentElement.scrollHeight;
        }
        scrollHeight =
            bodyScrollHeight - documentScrollHeight > 0
                ? bodyScrollHeight
                : documentScrollHeight;
        return scrollHeight;
    },
    getWindowHeight() {
        // 浏览器视口的高度
        let windowHeight = 0;
        if (document.compatMode === 'CSS1Compat') {
            windowHeight = document.documentElement.clientHeight;
        } else {
            windowHeight = document.body.clientHeight;
        }
        return windowHeight;
    },
    secondToDate(result) {
        // 秒转时分秒
        const h = Math.floor(result / 3600);
        const m = Math.floor((result / 60) % 60);
        const s = Math.floor(result % 60);
        if (h < 1) {
            return (result =
                this.numberFormartPolishing0(m) +
                ':' +
                this.numberFormartPolishing0(s));
        } else {
            return (result =
                this.numberFormartPolishing0(h) +
                ':' +
                this.numberFormartPolishing0(m) +
                ':' +
                this.numberFormartPolishing0(s));
        }
    },
   async getFrame(file){
        const video = document.createElement('video');
        const url = URL.createObjectURL(file);
        video.src = url;
        await new Promise((resolve) => {
            video.addEventListener('loadedmetadata', resolve);
        });
        const numThumbnails = 4; // 抽取 15 张缩略图，可按需调整
        const frames = [];
        const duration = video.duration;
        const width = video.videoWidth;
        const height = video.videoHeight;
        for (let i = 0; i < numThumbnails; i++) {
            const currentTime = (i / numThumbnails) * duration;
            video.currentTime = currentTime;
            await new Promise((resolve) => {
                video.addEventListener('seeked', resolve);
            });
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const imgData = canvas.toDataURL('image/png');
            frames.push(imgData);
        }
        return { frames,info:{duration,videoWidth:width,videoHeight:height}}
    },
     dataURLtoFile(dataurl, filename) {
        // 将base64转换为文件
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    },
    numberFormartPolishing0(num) {
        num = num.toString();
        if (num.length === 1) {
            num = '0' + num;
            return num;
        }
        return num;
    },
    trimStr(str) {
        return (str && str.replace(/(^\s*)|(\s*$)/g, '')) || str;
    },
    htmlEncode(html) {
        let temp = document.createElement('div');
        temp.textContent !== undefined
            ? (temp.textContent = html)
            : (temp.innerText = html);
        const output = temp.innerHTML;
        temp = null;
        return output;
    },
    // 只允许输入数字字母和中文
    filterInput(str: string): string {
        return str.replace(
            /[^\w\s\u4E00-\u9FA5"',，.。/、\]\\[【】！!?？——_\-<>%;‘’；:：)《（）》(&+=`“”·*#@@$￥]/g,
            ''
        );
    },
    // 去除换行回车符
    removeKineBreak(str: string): string {
        return str.replace(/[\r\n]/g, '');
    },
    getType(time: number) {
        return time < 10 ? '0' + time : time.toString();
    },
    getTime(duration: number) {
        const min = duration / 1000 / 60;
        const sec = (duration / 1000) % 60;
        return this.getType(min) + ':' + this.getType(sec);
    },
    getQueryString(name) {
        const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        const r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return decodeURI(r[2]);
        }
        return null;
    },
    removeQueryFromHtml(html) {
        const regex = /(https?:\/\/[\w./?=#&%-;]+)\b/g;
        return html.replace(regex, (match, url) => {
            const parsedUrl = new URL(url);
            return parsedUrl.origin + parsedUrl.pathname;
        });
    },
    removeQueryFromContent(content) {
        const removePosterQuery = content.replace(/(<video\b[^>]*poster="https?:\/\/[^"?]+)\?[^"]+"/g, '$1"');
        const regex = /<\s*(?:img)[^>]*?\b(?:src|source)=["']([^"']+)["']/gi;
        return removePosterQuery.replace(regex, (match, url) => {
            const urlObj = new URL(url);
            urlObj.search = '';
            const newUrl = urlObj.toString();
            return match.replace(url, newUrl);
        });
    },
     getToDetailHref(baseUrl, paramsObj){
        let params = new URLSearchParams();
        for (let key in paramsObj) {
             if (paramsObj[key]) {
                params.append(key, paramsObj[key]);
            }
        }
        return `${baseUrl}?${params.toString()}`;
    },
    secondsToTimeFormat(seconds: number) {

        const hours = Math.floor(seconds / 3600);
        const remainingSecondsAfterHours = seconds % 3600;
        const minutes = Math.floor(remainingSecondsAfterHours / 60);
        const remainingSeconds = Math.floor(remainingSecondsAfterHours % 60);

        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }
};

export default tool;
